import React, { useEffect, useRef, useState } from 'react';
import styles from './Keyboard.module.scss';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';

const FullKeyboard = ({ setInputValue, inputValue, close }) => {
    const [layoutName, setLayoutName] = useState('default');
    const [keyboardValue, setKeyboardValue] = useState(false);
    const keyboard = useRef();

    useEffect(() => {
        if (inputValue != null && keyboardValue !== inputValue) {
            keyboard.current.setInput(inputValue);
        }
    }, [inputValue]);

    const handleShift = () => {
        let newLayoutName = layoutName === 'default' ? 'shift' : 'default';
        setLayoutName(newLayoutName);
    };

    const onKeyPress = button => {
        console.log('Button pressed', button);

        /**
         * If you want to handle the shift and caps lock buttons
         */
        if (button === '{shift}' || button === '{lock}') handleShift();
    };

    const onChange = event => {
        setKeyboardValue(event);
        setInputValue(event);
    };

    return (
        <div className={styles.fullKeyboard}>
            <button className={`${styles.closeButton} icon-close-thin`} onClick={close} />
            <Keyboard
                keyboardRef={r => (keyboard.current = r)}
                layoutName={layoutName}
                layout={{
                    default: [
                        '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
                        '{tab} q w e r t y u i o p [ ] \\',
                        "a s d f g h j k l ; ' {enter}",
                        '{shift} z x c v b n m , . / {shift}',
                        '{alt} {space} {alt}',
                    ],
                    shift: [
                        '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
                        '{tab} Q W E R T Y U I O P { } |',
                        'A S D F G H J K L : " {enter}',
                        '{shift} Z X C V B N M < > ? {shift}',
                        '{alt} {space} {alt}',
                    ],
                }}
                onChange={input => onChange(input)}
                onKeyPress={button => onKeyPress(button)}
                display={{
                    '{enter}': 'Enter',
                    '{bksp}': '<',
                    '{tab}': 'Tab',
                    '{shift}': 'Shift',
                    '{alt}': 'Alt',
                    '{space}': ' ',
                }}
            />
        </div>
    );
};

export default FullKeyboard;
